import { render, staticRenderFns } from "./PageSettingsBackgroundImage.vue?vue&type=template&id=1a4bbfa1"
import script from "./PageSettingsBackgroundImage.vue?vue&type=script&lang=ts"
export * from "./PageSettingsBackgroundImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4bbfa1')) {
      api.createRecord('1a4bbfa1', component.options)
    } else {
      api.reload('1a4bbfa1', component.options)
    }
    module.hot.accept("./PageSettingsBackgroundImage.vue?vue&type=template&id=1a4bbfa1", function () {
      api.rerender('1a4bbfa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/document-settings/PageSettingsBackgroundImage.vue"
export default component.exports